<template>
  <div class="sm:px-10 md:px-32 lg:px-64 my-10 bg-gray-500 py-10">
    <BackButton @back="back('submit-request')" />
    <v-card>
      <v-card-title primary-title>
        Upgrade from lot to house and lot / Upgrade unit type
      </v-card-title>
      <v-card-text>
        <div class="flex">
          <div>Upgrade to:</div>
          <div class="flex mx-10">
            <div class="md:mr-2 w-full">
              <div>
                <v-btn outlined class="w-full mb-1" small> Larger Lot</v-btn>
              </div>
              <div>
                <v-btn outlined class="w-full" small>
                  Larger House and Lot</v-btn
                >
              </div>
            </div>
            <div class="w-full">
              <div>
                <v-btn outlined class="w-full mb-1" small>
                  Larger House Model</v-btn
                >
              </div>
              <div>
                <v-btn outlined class="w-full" small> Larger Condominium</v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card>
      <v-card-title primary-title>
        Upgrade to: Indicate the specific details of the new / requested
        property or house model.
      </v-card-title>
      <v-card-text>
        <div class="w-full border border-gray-400">
          <input class="w-full px-4 py-2" type="text" placeholder="Project" />
        </div>
        <div class="my-4 border border-gray-500 w-full">
          <input type="text" class="px-4 py-2 w-full" placeholder="Project" />
        </div>
        <div class="md:flex">
          <div class="w-1/2">
            <div>House and lot / Lot only</div>
            <div
              class="border-gray-900 border-2 mb-1 mr-2"
              v-for="(item, i) in house"
              :key="i"
            >
              <input
                class="py-1 px-4 w-full"
                type="text"
                :placeholder="item.placeholder"
              />
            </div>
          </div>
          <div class="w-1/2">
            <div>Condominium / Parking</div>
            <div
              class="border-gray-900 border-2 mb-1"
              v-for="(item, i) in condo"
              :key="i"
            >
              <input
                class="px-4 py-1 w-full"
                type="text"
                :placeholder="item.placeholder"
              />
            </div>
          </div>
        </div>
        <div class="w-full border border-gray-500 my-4">
          <textarea
            placeholder="Justification (Limit to 300 characters only)"
            class="px-4 py-2 w-full h-full"
          ></textarea>
        </div>
        <div>
          Any separate requests indicated in the ‘Justification’ will not be
          acknowledged for processing.
        </div>
      </v-card-text>
    </v-card>
    <v-card class="my-1">
      <v-card-title primary-title> Upload Sample Computation </v-card-title>
      <v-card-text>
        <div>
          Upload your signed Sample Computation and/or the signed House Layout
          and Perspective of the property where you are requesting to transfer
          to. You may get the mentioned documents from your authorized
          Seller/Broker.
        </div>
        <div class="my-1 flex items-center">
          <div class="border border-gray-500 w-1/2">
            <input type="text" class="w-full px-4 py-2" />
          </div>
          <v-btn color="lightblue">Add attachment</v-btn>
        </div>
        <div class="my-1 flex items-center">
          <div class="border border-gray-500 w-1/2">
            <input type="text" class="w-full px-4 py-2" />
          </div>
          <v-btn color="lightblue">Add attachment</v-btn>
        </div>
        <div class="my-1 flex items-center">
          <div class="border border-gray-500 w-1/2">
            <input type="text" class="w-full px-4 py-2" />
          </div>
          <v-btn color="lightblue">Add attachment</v-btn>
        </div>

        <input type="text" />
        <input type="text" />
      </v-card-text>
    </v-card>
    <v-card class="my-1">
      <v-card-text>
        <div>
          <v-card-title primary-title> Reminders and guidelines </v-card-title>
          <ul>
            <li>1. Your request will be subject for Management approval.</li>
            <li>
              2. You will need to continue your payments based on your current
              approved purchase and current payment terms even if you have
              submitted a request.
            </li>
            <li>
              3. Once submitted, you may see the status of your request on your
              Dashboard.
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
    <AlertDialog
      :showAlert="showAlert"
      @alertDialogSubmit="alertDialogSubmit"
    />
    <div class="my-2 w-full">
      <v-btn @click="submit" class="w-full" color="blue"> Submit Request</v-btn>
    </div>
  </div>
</template>

<script>
import AlertDialog from "../../common/AlertDialog.vue";
import BackButton from "../../common/BackButton.vue";
export default {
  data() {
    return {
      penalties_to_waive: "",
      showAlert: false,
    };
  },
  components: {
    AlertDialog,BackButton
  },
  methods: {
    back(n){
      this.$router.push({name:n})
    },
    submit() {
      this.showAlert = true;
    },
    alertDialogSubmit(name) {
      this.showAlert = false;
      !this.$route.path.includes(name) ? this.$router.push(name) : null;
    },
  },
};
</script>